module.exports = __webpack_public_path__ + "static/img/Geos-2022-Yuri.5fde95c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Yuri.png
// module id = H1a+
// module chunks = 0